<template>
  <div class="">
    <h4 v-if="AreIdsShown" style="background: orange; color: white">WidgetOtherRecordSelector</h4>

    <slot :recordsSelected="recordsSelected"></slot>
    <DxDataGrid
      class="widgetSummaryWorkGrid"
      :show-borders="true"
      :data-source="records"
      :selected-row-keys="selected"
      :row-alternation-enabled="true"
      :hover-state-enabled="true"
      :column-auto-width="true"
      :focused-row-enabled="true"
      :key-expr="idField"
      :word-wrap-enabled="true"
      ref="recordSelectionGridOTHER"
      noDataText="No Records were found ........"
      @cell-click="onCellClick"
      @row-expanding="onRowExpanding"
      @selection-changed="onSelectionChanged"
      @cell-prepared="onCellPrepared"
      @exporting="onExporting"
      @toolbar-preparing="onToolbarPreparing"
    >
      <DxColumn v-if="AreIdsShown" data-field="id" caption="O R S Id" />
      <DxColumn v-if="AreIdsShown" data-field="personId" caption="personId" />
      <!--
			<DxColumn data-field="userMessageId" caption="userMessageId" />-->

      <DxColumn data-field="dueText" caption="DUE" cell-template="dueText" />
      <template #dueText="{ data }">
        <span>{{ data.data.dueText }}</span>
      </template>

      <DxColumn data-field="priority" caption="Priority" cell-template="priority-cell" :width="60" />
      <template #priority-cell="{ data }">
        <div class="newStatusHi" style="padding: 0%">
          <div class="justify-content-center align-items-center" style="display: flex; padding: 0%; width: 100%">
            <div>
              <!-- {{ data.text }} -->

              <h6 class="mb-0" v-if="data.text === '0'">
                <span style="position: relative; display: inline-block; width: 2em; height: 2em">
                  <!-- Bottom filled circle (info) -->
                  <font-awesome-icon :icon="['fas', 'circle']" size="2x" style="color: #17a2b8; position: absolute; left: 0; top: 0; z-index: 1" />
                  <!-- Bell icon (white, centered) -->
                  <font-awesome-icon :icon="['fas', 'bell']" size="1x" style="color: white; position: absolute; left: 0.45em; top: 0.45em; font-size: 1.2em; z-index: 2" />
                  <!-- Top outline circle (danger) -->
                  <font-awesome-icon :icon="['far', 'circle']" size="2x" style="color: #dc3545; position: absolute; left: 0; top: 0; z-index: 3" />
                </span>
              </h6>
              <h6 class="mb-0" v-if="data.text === '1'">
                <span style="position: relative; display: inline-block; width: 2em; height: 2em; background: MistyRose; border-radius: 0.5em">
                  <!-- Bottom diamond (filled) -->
                  <font-awesome-icon :icon="['fas', 'diamond']" size="2x" style="color: #ffc107; position: absolute; left: 0; top: 0; z-index: 1" />
                  <!-- Exclamation, centered and larger -->
                  <font-awesome-icon :icon="['fas', 'exclamation']" size="lg" style="color: #dc3545; position: absolute; left: 0.55em; top: 0.25em; font-size: 1.5em; z-index: 2" />
                  <!-- Top diamond (outline, optional for effect) -->
                  <!-- <font-awesome-icon :icon="['fas', 'diamond']" size="2x" style="color: #ffc107; position: absolute; left: 0; top: 0; z-index: 3" /> -->
                </span>
              </h6>
              <h6 class="mb-0" v-if="data.text === '2'">
                <span style="position: relative; display: inline-block; width: 2em; height: 2em">
                  <!-- Bottom filled circle (danger) -->
                  <font-awesome-icon :icon="['fas', 'circle']" size="2x" style="color: #dc3545; position: absolute; left: 0; top: 0; z-index: 1" />
                  <!-- Exclamation circle (white, centered) -->
                  <font-awesome-icon :icon="['fas', 'exclamation-circle']" size="lg" style="color: white; position: absolute; left: 0.17em; top: 0.25em; font-size: 1.5em; z-index: 2" />
                  <!-- Top outline circle (danger) -->
                  <font-awesome-icon :icon="['far', 'circle']" size="2x" style="color: #dc3545; position: absolute; left: 0; top: 0; z-index: 3" />
                </span>
              </h6>
            </div>
          </div>
        </div>
      </template>
      <DxColumn data-field="messageSubject" caption="Subject" />
      <DxColumn data-field="sentBy" caption="Sent By" />

      <DxColumn data-field="dueDate" caption="DUE" cell-template="formatDate-template" />
      <DxColumn data-field="startDate" caption="START" cell-template="formatDate-template" />
      <DxColumn data-field="recievedDate" caption="Recieved" cell-template="formatDate-template" />

      <DxColumn data-field="taskType" caption="Task Type" />
      <DxColumn data-field="taskCount" caption="Task Count" />
      <DxColumn data-field="clinicalItems" caption="Clinical Items" />
      <DxColumn data-field="attachments" caption="Attachments" />

      <!-- <DxColumn data-field="personId" caption="PersonId" />
			<DxColumn data-field="lastName" caption="Last Name" cell-template="lastName" />
			<DxColumn data-field="firstName" caption="First Name" cell-template="firstName" />
			<DxColumn data-field="middleName" caption="Middle" />
			<DxColumn data-field="dateOfBirth" caption="DOB" cell-template="formatDate-template" />
			<DxColumn data-field="lastSeen" caption="Last Seen" cell-template="formatDate-template" />
			<DxColumn data-field="lastSeenBy" caption="Last Seen by" />
			<DxColumn data-field="nextAppointment" caption="Next Appointment" sort-order="desc" cell-template="formatDate-template" />
			<DxColumn data-field="taskCount" alignment="left" caption="Task Count" />-->

      <DxExport :enabled="true" />
      <DxPaging :enabled="true" :pageSize="50" />

      <DxSelection :select-all-mode="allMode" :show-check-boxes-mode="checkBoxesMode" mode="multiple" />

      <dx-search-panel :visible="false" />
      <DxHeaderFilter :visible="false" />
      <DxFilterRow :visible="false" />
      <template #formatDate-template="{ data }">
        <span>{{ useFormatDate(data.text) }}</span>
      </template>
      <DxMasterDetail :enabled="true" template="details" :auto-expand-all="false" />
      <template #details="{ data }">
        <span style="background: transparent; padding: 0px">
          <h6 v-if="AreIdsShown" style="color: green">My OTHER WorkDetails > fetchMyWorkDetails currentPersonId {{ currentPersonId }}</h6>
          <h6 v-if="AreIdsShown" style="color: blue">My OTHER WorkDetails > id: currentMessageId {{ currentMessageId }}</h6>

          <!-- {{ currentMessageId }} -->
          <!-- <MyOtherWorkDetails :getRecords="workListsApi.fetchMyOtherWorkDetails()" :id="currentMessageId" /> -->
          <MyOtherWorkDetails :dataRow="data.data" />
        </span>
      </template>
    </DxDataGrid>
  </div>
</template>

<script setup>
import { ref, onMounted, reactive } from "vue";
import { DxDataGrid, DxColumn, DxPaging, DxFilterRow, DxHeaderFilter, DxMasterDetail, DxSelection, DxExport, DxSearchPanel, DxColumnFixing, DxScrolling } from "devextreme-vue/data-grid";

import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";

import { usePatientStore } from "@/stores/patientStore";
import moment from "moment";

import MyOtherWorkDetails from "./MyOtherWorkDetails.vue";
// ? test
import { customers } from "./WidgetRecordSelectorData.ts";

const patientStore = usePatientStore();

// * EMITTER
const emit = defineEmits(["recordsSelectedRows", "recordsSelected"]);
// & PROPS
const props = defineProps({
  records: {
    type: Array,
    required: true,
    default: () => [],
  },
  fields: {
    type: Array,
    required: false,
    default: () => [],
  },
  idField: {
    type: String,
    required: false,
  },
  selected: {
    type: Array,
    required: false,
  },
  handleOnCellPrepared: {
    type: Function,
    required: false,
  },
  FromLabs: {
    type: Boolean,
    required: false,
  },
  selectedFileName: {
    type: String,
    default: () => {},
  },
});

// ~ string Template TEST
const name = "thomas";
const job = "Window Washer";

const cCatStrings = "Hi my name is " + name + " and I am a " + job;
// * USEs  BACKTICKs
const templateSTRING = `Hi, my name is  is     ${name}`;

// & COMPOSIBLEs
import { useMouse } from "@/use/mouse.js";
import { useFormatDate } from "@/use/formatDate.js";

const { x, y } = useMouse();

// const dateCh = useFormatDate()

const AreIdsShown = ref(false);
const currentTask = reactive({});

let currentPersonId = ref("");
let currentMessageId = ref("");

let workDetailRecords = ref([]);

function onCellPrepared(e) {
  // console.clear();
  // console.log("E");
  // console.log(e);
  // console.log(e.column.dataField);

  if (e.column.dataField === "dueText") {
    // console.log("DUE");
    // console.log(e);
    // console.log(e.data?.dueText);

    if (e.column.dataField === "dueText") {
      switch (e.data?.dueText) {
        case "Overdue":
          e.cellElement.style.backgroundColor = "#8a11118a";
          e.cellElement.style.color = "#e0f2e1";
          e.cellElement.style.fontWeight = "bold";
          e.cellElement.style.fontSize = "1.0rem"; // or "20px" or any size you want
          e.cellElement.style.width = "100%";
          e.cellElement.style.display = "flex";
          e.cellElement.style.alignItems = "center";
          e.cellElement.style.justifyContent = "center";
          e.cellElement.style.textAlign = "center";
          e.cellElement.style.height = "100%";
          e.cellElement.style.textTransform = "uppercase";
          break;
        case "Next 7 Days":
          e.cellElement.style.backgroundColor = "#4caf50"; // "#b7e18a8a";
          // e.cellElement.style.color = "#222";
          break;
        case "Next 8-14 Days":
          // Even lighter red
          e.cellElement.style.backgroundColor = "#ffca45"; // "#e1b84d8a";
          e.cellElement.style.color = "#222";
          break;
        case "Next 15-30 Days":
          // Orange-red
          e.cellElement.style.backgroundColor = "#e1b84d8a";
          // e.cellElement.style.color = "#ff6a45";
          break;
        case "Next 31-90 Days":
          // Yellow-orange
          e.cellElement.style.backgroundColor = "#d17a4d8a";
          // e.cellElement.style.color = "#222";
          break;
        case "Over 90 to EOY":
          // Light yellow-green
          e.cellElement.style.backgroundColor = "transparent";
          // e.cellElement.style.color = "#222";
          break;

        case "Completed":
          e.cellElement.style.backgroundColor = "#4caf50";
          e.cellElement.style.color = "#fff";
          break;
        default:
          // e.cellElement.style.backgroundColor = "#9aa99b";
          // e.cellElement.style.color = "#e3f4e5";
          break;
      }
    }
  }

  if (!props.handleOnCellPrepared) return;
  props.handleOnCellPrepared(e);

  // console.log(props.handleOnCellPrepared(e));
}
function onExporting(e) {
  // console.clear();
  // console.log(e);
  // console.log(e.fileName);
  // * NEW FILENAME BINDING
  e.fileName = props.selectedFileName;
  // console.log(e.fileName);

  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet("Main sheet");
  exportDataGrid({
    component: e.component,
    worksheet: worksheet,
    customizeCell: function (options) {
      options.excelCell.font = { name: "Arial", size: 12 };
      options.excelCell.alignment = { horizontal: "left" };
    },
  }).then(function () {
    // console.log(" 												  ... saveAS");

    workbook.xlsx.writeBuffer().then(function (buffer) {
      saveAs(new Blob([buffer], { type: "application/octet-stream" }), e.fileName + ".xlsx");
    });
  });
}
function onToolbarPreparing(e) {
  // console.dir(e);
  var item = e.toolbarOptions.items.find((item) => item.name === "exportButton");
  // console.log("item");
  // console.log(item.style.width='150px')

  // // console.log('       item opts')
  //
  // console.log(item);

  // item.options.icon: 'export',
  item.showText = "always";
}
async function onRowExpanding(e) {
  // //console.clear()()
  // console.log("   	   	endOf												DASH   REC SELECTOR  onRowExpanding :  collapseAll");
  e.component.collapseAll(-1);

  // console.log("E: ");
  // console.dir(e);
  // console.dir(e.component.currentPersonId);
  // console.dir(e.row.data);

  //console.log('this.currentPersonId  ')
  //console.log(this.currentPersonId)
  // console.log(">>>>>>>>>>>>>>>>>>>>>>>> SETS current Persion ID   >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");

  currentPersonId = e.component.currentPersonId;
  // console.log("currentPersonId ");
  // console.log(currentPersonId);
  // console.log("((((((((");

  // onCellClick(e);
}
function onSelectionChanged(e) {
  ////console.log(' OPEN on ROW select   TEST #1')
  // ////console.dir(e)
  // console.log("									DASH REC SELECT: 	onSelectionChanged(e)");
  e.component.collapseAll(-1);
  e.component.expandRow(e.currentSelectedRowKeys[0]);

  //console.log(e.selectedRowsData)

  this.recordsSelected = e.selectedRowsData;

  // console.log(this.recordsSelected);

  //console.log('	***	 Record SEL:  onSelChang : ', e.selectedRowsData)
  //console.dir(this.recordsSelected[0])

  // console.log(" WidRecSel   TODO  build EMIITERs / test ");
  //   //! EMITTER :  ROW W/   RECORD OBJ
  //   this.$emit(    "recordsSelectedRows",    this.recordsSelected.map((record) => record)  );
  emit(
    "recordsSelectedRows",
    this.recordsSelected.map((record) => record)
  );

  //   //? EMITTER :  Map: rec => rec[idField]
  //   this.$emit(    "recordsSelected",    this.recordsSelected.map((record) => record.personId)  );
  emit(
    "recordsSelected",
    this.recordsSelected.map((record) => record.personId)
  );
}
function onCellClick(e) {
  ////console.clear()()
  // console.log("****************************************************");
  // console.log("		My OTHER Record Selector													onCellClick (e) ");
  // console.dir(e);
  // & NEW
  this.currentTask = e.row.data;
  // console.dir(this.currentTask);

  const cPerson = e.row.data.personId;

  // console.log("			cPerson", cPerson);

  // this.$store.commit('setCurrentPatient', this.currentTask)
  patientStore.setCurrentPatient(this.currentTask);

  // this.checkForSingleTask()
  this.currentPersonId = this.currentTask.personId;
  // this.$store.commit('setPatientId', this.currentPersonId)
  // console.log("		***			>>>>>>>>>>>>>>>>>>    STORE  		setPatientId           	patientStore.currentPatientId = this.currentPersonId");

  patientStore.currentPatientId = this.currentPersonId;

  this.currentMessageId = this.currentTask.id;
  // console.log("	  	My OTHER Record Selector			        this.currentTask.id     > 	this.currentMessageId", this.currentMessageId);
}
onMounted(() => {
  //   console.clear();
  // console.log("onMounted() :		  WidgetOtherRecordSelector   >>>>");
  // console.log(" prop   records ");
  // console.log("props : ");
  // console.log(props);
  // console.log({ ...props.records });
});
</script>

<style lang="scss" scoped>
.page-grid-wrapperDash {
  background: darkkhaki;
  padding: 6px;
  overflow: auto;
}

.detailsSlot {
  background: transparent; // #007f8b !important;
  padding: 0px;
}

a {
  text-decoration: none;
  font-weight: bolder;
  // color: #83ff7d;
  //background:#dcf1de;
}

// .DxSelection td {
// 	background: rgb(227, 255, 17) !important;
// }
// .dx-row-focused.dx-data-row > td:not(.dx-focused),
//.dx-row-focused.dx-data-row > tr > td:not(.dx-focused) ,
//.dx-row-focused.dx-data-row>tr>td>a:not(.dx-focused) {
//background-color: #e59807; //95c6ef
//color: rgb(255, 251, 9);
//}

// .dx-datagrid-rowsview
// 	.dx-row-focused.dx-data-row
// 	.dx-command-edit:not(.dx-focused)
// 	.dx-link,
// .dx-datagrid-rowsview .dx-row-focused.dx-data-row > td:not(.dx-focused),
// .dx-datagrid-rowsview .dx-row-focused.dx-data-row > tr > td:not(.dx-focused) {
// 	background-color: #bcb91a;
// 	color: rgb(151, 27, 176);
// }
a.nav-link {
  display: block;
  // background-color: #bcb91a;
  padding: 0%;
  // PRORITY ICON   AREA   background: darkblue;
}
#grid-container {
  height: 440px;
}
</style>

<style lang="scss" scoped>
a {
  text-decoration: underline;
}

a.nav-link {
  display: block;
  // background-color: #bcb91a;
  padding: 0%;
}

// tr.DxSelection a {
//   color: #eaf7eb;
// }
</style>
